module.exports = __webpack_public_path__ + "static/learning-theories-game-504d4e1177b9b6077c0a14ad4d131ba6.gif";